import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Sidebar from "../shared/Sidebar";

function Hvac() {
 
 const baseUrl = process.env.baseUrl;
   const navigate = useNavigate();

  const [formData, setFormData] = useState({
    chillers: "",
    chillerType: "",
    coolingTowers: "",
    vfds: "",
    calorifiers: "",
    fahus: "",
    ahus: "",
    fcus: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const validate = () => {
    const newErrors = {};
    for (let field in formData) {
      if (!formData[field]) {
        newErrors[field] = "This field is required";
      }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    try {
      await axios.post("/api/hvac", formData); // Adjust the API endpoint accordingly
      navigate("/scada");
    } catch (err) {
      console.error("Submission failed:", err);
      alert("Failed to submit HVAC data. Please try again.");
    }
  };

  return (
    <div className="container col-lg-9 mt-5">
      <div className="row">
        <div className="col-md-4">
          <Sidebar />
        </div>

        <div className="col-md-8">
          <div className="form-section">
            <h5 className="mb-4">HVAC & Refrigeration</h5>
            <form onSubmit={handleSubmit}>
              <div className="row mb-3">
                {[
                  { name: "chillers", label: "Chillers – Quantity + Capacity" },
                  { name: "chillerType", label: "Chiller Type" },
                  { name: "coolingTowers", label: "Cooling Towers (spec)" },
                  { name: "vfds", label: "VFDs for HVAC" },
                  { name: "calorifiers", label: "Calorifiers" },
                  { name: "fahus", label: "No. Of FAHUs and their capacity" },
                  { name: "ahus", label: "No. Of AHUs and their capacity" },
                  { name: "fcus", label: "No. Of FCUs and their capacity" },
                ].map((field, index) => (
                  <div
                    key={field.name}
                    className={`${
                      index < 6 ? "col-md-12" : "col-md-6"
                    } mb-3`}
                  >
                    <input
                      type="text"
                      className={`form-control ${
                        errors[field.name] ? "is-invalid" : ""
                      }`}
                      name={field.name}
                      placeholder={field.label}
                      value={formData[field.name]}
                      onChange={handleChange}
                    />
                    {errors[field.name] && (
                      <div className="invalid-feedback">
                        {errors[field.name]}
                      </div>
                    )}
                  </div>
                ))}
              </div>

              <button type="submit" className="btn btn-custom w-100">
                Continue →
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hvac;
